import React from "react"

import { Grid, Card, Typography } from "@material-ui/core"
import { BarChart, ChatBubbleOutlineOutlined, TrackChangesOutlined } from "@material-ui/icons"

import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinkMetrics/MetricCards/styles"

type MetricCardsProps = {
	clicksCount: number
	sentMessagesCount: number
	percentageOfConversationsTracked: number
}

const MetricCards: React.FC<MetricCardsProps> = (props) => {
	const { clicksCount, sentMessagesCount, percentageOfConversationsTracked } = props

	const classes = useStyles()

	return (
		<Grid
			container
			spacing={3}
		>
			<Grid item xs={4}>
				<Card className={`${classes.purple} ${classes.card}`}>
					<Grid container justifyContent="space-between" alignItems="center">
						<Grid item>
							<Typography variant="h5" className={classes.cardTitle}>{clicksCount}</Typography>
						</Grid>
						<Grid item>
							<TrackChangesOutlined fontSize="large" />
						</Grid>
					</Grid>
					<Typography variant="body1" className={classes.cardSubtitle}>Cliques</Typography>
				</Card>
			</Grid>

			<Grid item xs={4}>
				<Card className={`${classes.green} ${classes.card}`}>
					<Grid container justifyContent="space-between" alignItems="center">
						<Grid item>
							<Typography variant="h5" className={classes.cardTitle}>{sentMessagesCount}</Typography>
						</Grid>
						<Grid item>
							<ChatBubbleOutlineOutlined fontSize="large" />
						</Grid>
					</Grid>
					<Typography variant="body1" className={classes.cardSubtitle}>Enviaram mensagem</Typography>
				</Card>
			</Grid>

			<Grid item xs={4}>
				<Card className={`${classes.blue} ${classes.card}`}>
					<Grid container justifyContent="space-between" alignItems="center">
						<Grid item>
							<Typography variant="h5" className={classes.cardTitle}>{percentageOfConversationsTracked}%</Typography>
						</Grid>
						<Grid item>
							<BarChart fontSize="large" />
						</Grid>
					</Grid>
					<Typography variant="body1" className={classes.cardSubtitle}>Das conversas rastreadas</Typography>
				</Card>
			</Grid>
		</Grid>
	)
}

export default MetricCards
